import React from 'react'
import parse from 'html-react-parser'
import ArrowLeft from '../assets/images/left-service-arrow.png'
import ArrowRight from '../assets/images/right-service-arrow.png'
import Zigzag from '../assets/images/zigzag-arrow.png'
import CircleArrow from '../assets/images/arrow-04.png'
import Fade from "react-reveal/Fade";

const ServiceBanner = ({title, backgroundColour}) => {

  return (
    <section className={`service-banner service-banner--${backgroundColour}`}>
      <Fade bottom distance='40px'>
        <div className='service-banner__inner'>
          <div className='service-banner__title' data-sal='fade' data-sal-duration='1000' data-sal-delay='0'
               data-sal-easing='ease'>
            {backgroundColour === 'green' && <img src={ArrowLeft} alt="arrow"/>}
            {title && <h1>{parse(title)}</h1>}
            {backgroundColour === 'green' && <img src={ArrowRight} alt="arrow"/>}
            {backgroundColour === 'mauve' && <img src={Zigzag} alt="arrow"/>}
            {
              backgroundColour === 'blue' &&
              <div className='arrow'>
                <img src={CircleArrow} alt="arrow"/>
              </div>
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default ServiceBanner